package com.milta.core.localization.translations.ro

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 adresă nelocalizată",
    warningTitlePlural = "%d adrese nelocalizate",
    warningMessage = "Aceste livrări nu au putut fi plasate pe hartă. Corectați adresa lor sau continuați: vor fi puse la sfârșitul turei.",
    fixAction = "Corectează",
    continueWithoutAction = "Continuă fără ele",
    unplacedStopsSingular = "1 oprire neplasată, la sfârșitul turei",
    unplacedStopsPlural = "%d opriri neplasate, la sfârșitul turei",
    fixAddressAction = "Corectează adresa",
    unlocatedBadge = "Nelocalizată",
)
